/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Upgrade_SubscriptionInputs */

const en_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`upgrade your Cobot subscription`)
};

const de_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot-Tarif aktualisieren`)
};

const es_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actualiza tu suscripción de Cobot`)
};

const fr_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mettre à niveau votre abonnement Cobot`)
};

const it_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aggiorna il tuo abbonamento Cobot`)
};

const pt_br2_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atualize sua assinatura da Cobot`)
};

const pl_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zaktualizuj swoją subskrypcję Cobot`)
};

const hu_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobot előfizetés frissítése`)
};

const ro_admin_dashboard_upgrade_subscription = /** @type {(inputs: Admin_Dashboard_Upgrade_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`faceti upgrade la abonamentul dumneavoastra Cobot`)
};

/**
* | output |
* | --- |
* | "upgrade your Cobot subscription" |
*
* @param {Admin_Dashboard_Upgrade_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_upgrade_subscription = /** @type {((inputs?: Admin_Dashboard_Upgrade_SubscriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Upgrade_SubscriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_upgrade_subscription(inputs)
	if (locale === "de") return de_admin_dashboard_upgrade_subscription(inputs)
	if (locale === "es") return es_admin_dashboard_upgrade_subscription(inputs)
	if (locale === "fr") return fr_admin_dashboard_upgrade_subscription(inputs)
	if (locale === "it") return it_admin_dashboard_upgrade_subscription(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_upgrade_subscription(inputs)
	if (locale === "pl") return pl_admin_dashboard_upgrade_subscription(inputs)
	if (locale === "hu") return hu_admin_dashboard_upgrade_subscription(inputs)
	return ro_admin_dashboard_upgrade_subscription(inputs)
});
export { admin_dashboard_upgrade_subscription as "admin.dashboard.upgrade_subscription" }